export enum EHeaderDBMaster {
    AUTHORIZATION_AM = 'x-am-authorization', // if API is not public then this token is mandatory.
    AUTHORIZATION_AM_USER = 'x-am-user-authorization', // used tor EAuthTokenType
    AUTHORIZATION_AWS = 'x-aws-authorization', // used tor EAuthTokenType
    AUTHORIZATION_GOOGLE = 'x-google-authorization', // used tor EAuthTokenType
    AUTHORIZATION_AZURE = 'x-azure-authorization', // used tor EAuthTokenType

    // New Headers
    DB_MASTER_NAME = 'db-master-name',
    ADMIN_PATH = 'admin-path',
    THEME = 'theme', // Used to pass it from URL query params.
    WAIT_FOR_PARENT_READY = 'wait-for-parent-ready', // true | false // If passed, master will wait until parent is done with setting its data.
    SHOW_LOGS = 'show-logs', // default false. if true system will print logs.
}

export enum IDBMasterEventFromIframeToParent {
    PAGE_READY = 'PAGE_READY',
    RECORD_SAVED = 'RECORD_SAVED',
    RECORDS_IMPORTED = 'RECORDS_IMPORTED',
    RECORD_UPDATED = 'RECORD_UPDATED',
    RECORD_DELETED = 'RECORD_DELETED',
    MANY_RECORD_DELETED = 'MANY_RECORD_DELETED',
    GRID_EXPORTED = 'GRID_EXPORTED',
    GRID_REFRESHED = 'GRID_REFRESHED',
    ADD_NEW_BUTTON_CLICKED = 'ADD_NEW_BUTTON_CLICKED',
    CUSTOM_ACTION_BUTTON_CLICKED = 'CUSTOM_ACTION_BUTTON_CLICKED',
    DROPDOWN_ADD_NEW_RECORD_SAVED = 'DROPDOWN_ADD_NEW_RECORD_SAVED',
    CLOSE_BUTTON_CLICKED = 'CLOSE_BUTTON_CLICKED',
}

export enum IDBMasterEventFromParentToIframe {
    TRIGGER_ADD_NEW_BUTTON_CLICK = 'TRIGGER_ADD_NEW_BUTTON_CLICK',
    TRIGGER_REFRESH_BUTTON_CLICK = 'TRIGGER_REFRESH_BUTTON_CLICK',
    DATA_TO_APPEND_IN_GRID_LOAD_FIND_QUERY = 'DATA_TO_APPEND_IN_GRID_LOAD_FIND_QUERY',
    DATA_TO_APPEND_IN_RECORD_SAVE_API_PAYLOAD = 'DATA_TO_APPEND_IN_RECORD_SAVE_API_PAYLOAD',
    DATA_TO_APPEND_IN_RECORD_UPDATE_API_PAYLOAD = 'DATA_TO_APPEND_IN_RECORD_UPDATE_API_PAYLOAD',
    SET_GLOBAL_DATA_TO_USE_IN_ANY_SCRIPT = 'SET_GLOBAL_DATA_TO_USE_IN_ANY_SCRIPT',
    PARENT_READY = 'PARENT_READY', // parent will send message when it is ready with grid conditions.
}
